export const UPDATE = 'UPDATE';
export const UPDATE_ALL_ORDERS = 'UPDATE_ALL_ORDERS';
export const ALL_ORDERS = 'ALL_ORDERS';
